import { Box } from "@mui/material";
import NoPlansBanner from "components/common/NoPlansBanner";
import { triggerOnboadingWizard } from "components/features/Onboarding/Helper";
import {
  fetchSuggestedPlansAsync,
  fetchSuggestedPlansIdAsync,
  resetSuggestedListIds,
  setSuggestedPlanList
} from "components/features/dashboard/HotelUserDashboard.slice";
import { getHotelUserDashboardInncode } from "components/features/dashboard/HotelUserDashboardHelper";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { pageNames } from "utils/Types";
import List from "./List";
import "./index.scss";

const AllPlans = () => {
  const dispatch = useAppDispatch();

  const [planTypesCmsIds, setPlanTypesCmsIds] = useState<string[]>([]);

  const plansList = useAppSelector((state) => state.hotelUserDashboardSlice.suggestedPlans.SuggestedPlansList);
  const suggestedPlanIds: any = useAppSelector((state) => state.hotelUserDashboardSlice.suggestedPlans.listIds);
  const [searchParams] = useSearchParams();
  const externalHltId = searchParams.get("member");
  const innCode = getHotelUserDashboardInncode();

  useEffect(() => {
    if (innCode) dispatch(fetchSuggestedPlansIdAsync({ innCode: innCode, externalHltId }));
  }, [innCode]);

  useEffect(() => {
    return () => {
      dispatch(resetSuggestedListIds());
      dispatch(setSuggestedPlanList());
    };
  }, []);

  useEffect(() => {
    if (suggestedPlanIds?.length > 0) {
      const cmsIds = suggestedPlanIds
        ?.filter(
          (item: any) =>
            item?.breadCrumbPlanType === "recommended_criteria" || item?.breadCrumbPlanType === "recommended_default"
        )
        .map((i: any) => i?.cmsId);

      if (cmsIds.length > 0) {
        setPlanTypesCmsIds(cmsIds);
      } else {
        dispatch(setSuggestedPlanList());
      }

      return;
    }
  }, [suggestedPlanIds]);

  useEffect(() => {
    if (planTypesCmsIds?.length > 0) {
      const getSuggestedPlans = async () => {
        const props: any = {
          externalHltId,
          filter: {
            innCode,
            ids: planTypesCmsIds
          },
          pagination: {
            page: 1,
            size: 5
          },
          isSortingDisabled: true,
          myPlansDisabled: true
        };
        await dispatch(fetchSuggestedPlansAsync(props));
      };
      getSuggestedPlans();
    }
  }, [planTypesCmsIds]);

  return (
    <>
      {plansList?.length > 0 ? (
        <List plansList={plansList} />
      ) : (
        <Box className="no-plans-banner">
          <NoPlansBanner
            isDashboard
            pageName={pageNames.suggested}
            onClickHandle={() => triggerOnboadingWizard(dispatch)}
          />
        </Box>
      )}
    </>
  );
};
export default AllPlans;
